import React from "react";
import CaseSim from "../elements/case-sim";

export default function CaseBreakdown() {
  const searchTags = [
    "High Phytanic Acid",
    "Retinitis Pigmentosa",
    "Ataxia",
    "Tangling Sensation",
  ];
  const topic =
    "dolore in magna deserunt consequat do consectetur sint tempor reprehenderit do sunt eiusmod aliquip fugiat anim dolor dolor eu deserunt";
  return <CaseSim header={"Case Breakdown"} topic={topic} />;
}
